import * as yup from "yup";
import { subYears } from "date-fns";

/* ---------------------------
Reusable Social URL Validator
----------------------------*/
const socialUrl = (domain, message) =>
  yup.string().nullable().test("url-validation", message, (value) => {
    if (!value) return true;
    const regex = new RegExp(`^(https?:\\/\\/)?(www\\.)?${domain}\\/.*`, "i");
    return regex.test(value);
  });

export const profileSchema = yup.object().shape({
  fullName: yup
    .string()
    .required("Name is required")
    .min(3, "At least 3 chars"),

  email: yup
    .string()
    .email("Invalid email")
    .required("Email is required"),

  mobileNumber: yup
    .string()
    .matches(/^[+]?[0-9]{10,15}$/, "Invalid mobile")
    .required("Mobile is required"),

  alternateMobileNumber: yup.string().nullable(),

  // educationLevel: yup
  //   .string()
  //   .required("Education Level is required"),
 educationLevel: yup.object().shape({
    value: yup.string().required('Education Level is required'),
    label: yup.string().required(),
  }).nullable().required('Education Level is required'),


  dateOfBirth: yup
    .date()
    .nullable()
    .max(new Date(), "Date cannot be in future")
    .min(subYears(new Date(), 100), "Date cannot be more than 100 years ago"),

  gender: yup.object().shape({
      value: yup.string().nullable(),
      label: yup.string().nullable(),
  }).nullable(),
  // specialCategory: yup.string().nullable(),
   specialCategory: yup.object().shape({
      value: yup.string().nullable(),
      label: yup.string().nullable(),
  }).nullable(),

  nationality: yup.object().shape({
      value: yup.string().nullable(),
      label: yup.string().nullable(),
  }).nullable(),

  countryOfResidence: yup.object().shape({
      value: yup.string().nullable(),
      label: yup.string().nullable(),
  }).nullable(),

  preferredCurrency: yup.object().shape({
      value: yup.string().nullable(),
      label: yup.string().nullable(),
  }).nullable(),

  talents: yup
    .array()
    .min(1, "Select at least one talent")
    .required("Talent is required"),

  aboutYourself: yup.string().nullable(),

  /* ---------------------------
     PAN / Aadhar Validation
  ----------------------------*/

  panNumber: yup
  .string()
  .nullable()
  .test(
    "pan-validation",
    "Invalid PAN Card format",
    function (value) {
      if (!value) return true;
      return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value.toUpperCase());
    }
  ),

  aadharNumber: yup
  .string()
  .nullable()
  .test(
    "aadhar-validation",
    "Aadhar must be 12 digits",
    function (value) {
      if (!value) return true;
      return /^\d{12}$/.test(value);
    }
  ),

  /* ---------------------------
     Physical Attributes
  ----------------------------*/

weight: yup.number().transform((val, orig) => (orig === "" ? null : val)).nullable().min(1, "Min 1 Kg").max(300, "Max 300 Kg"),
heightFeet: yup.number().transform((val, orig) => (orig === "" ? null : val)).nullable().min(1, "Min 1 foot").max(8, "Max 8 feet"),
heightInches: yup.number().transform((val, orig) => (orig === "" ? null : val)).nullable().min(0, "Min 0 inch").max(11, "Max 11 inches"),
eyeColour: yup.object().shape({ value: yup.string().nullable(), label: yup.string().nullable() }).nullable(),
skinType: yup.object().shape({ value: yup.string().nullable(), label: yup.string().nullable() }).nullable(),
bodyType: yup.object().shape({ value: yup.string().nullable(), label: yup.string().nullable() }).nullable(),
hairType: yup.object().shape({ value: yup.string().nullable(), label: yup.string().nullable() }).nullable(),
hairColor: yup.object().shape({ value: yup.string().nullable(), label: yup.string().nullable() }).nullable(),


  // peopleAppearanceList: yup.string().nullable(),
  peopleAppearanceList: yup.object().shape({
      value: yup.string().nullable(),
      label: yup.string().nullable(),
  }).nullable(),

  // drivingType: yup.string().nullable(),
  drivingType: yup.object().shape({
      value: yup.string().nullable(),
      label: yup.string().nullable(),
  }).nullable(),

  sportsType: yup.array().nullable(),

  esportsType: yup.array().nullable(),

  /* ---------------------------
     Address
  ----------------------------*/

  // addressType: yup.string().default("primary"),
  addressType: yup.string().nullable(),
  pinCode: yup
    .string()
    .nullable()
    .test("pincode-check", "Pin Code must be 6 digits", (val) => !val || /^\d{6}$/.test(val)),
  addressLine1: yup.string().nullable(),
  addressLine2: yup.string().nullable(),
  state: yup.string().nullable(),
  district: yup.string().nullable(),

  /* ---------------------------
     Social Media Validation
  ----------------------------*/

  facebookProfileUrl: socialUrl(
    "facebook.com",
    "Enter valid Facebook URL"
  ),

  linkedinProfileUrl: socialUrl(
    "linkedin.com",
    "Enter valid LinkedIn URL"
  ),

  instagramProfileUrl: socialUrl(
    "instagram.com",
    "Enter valid Instagram URL"
  ),

  twitterProfileUrl: socialUrl(
    "x.com",
    "Enter valid Twitter URL"
  ),

  youtubeUrl: socialUrl(
    "(youtube.com|youtu.be)",
    "Enter valid YouTube URL"
  ),

  imdbUrl: socialUrl(
    "imdb.com",
    "Enter valid IMDB URL"
  ),

  whatsappNo: yup.string().nullable(),
});